import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import { MemoryRouter, Route, Routes, useNavigate } from "react-router-dom";
import MyVaultViewsLayout from "./MyVaultViewsLayout";

const mockWidgetMounted = jest.fn();

jest.mock("../../../providers/WorkspaceProvider", () => ({
  useWorkspaceContext: () => ({ workspace: { id: "workspace-1" } }),
}));
jest.mock("../components/MyVaultAgent", () => ({
  FloatingChatWidget: ({ workspaceId }: { workspaceId: string }) => {
    const mockReact = jest.requireActual("react");
    mockReact.useEffect(() => {
      mockWidgetMounted();
    }, []);
    return mockReact.createElement(
      "div",
      { "data-testid": "assistant-widget" },
      workspaceId,
    );
  },
}));

function ViewRoute({
  title,
  destination,
}: {
  title: string;
  destination: string;
}) {
  const navigate = useNavigate();
  return <button onClick={() => navigate(destination)}>{title}</button>;
}

it("keeps the same assistant mounted while navigating from the Views list to a view", () => {
  mockWidgetMounted.mockClear();
  render(
    <MemoryRouter initialEntries={["/workspace-1/myvault/views"]}>
      <Routes>
        <Route
          path="/workspace-1/myvault/views"
          element={<MyVaultViewsLayout />}
        >
          <Route
            index
            element={
              <ViewRoute
                title="Views list"
                destination="/workspace-1/myvault/views/view-1"
              />
            }
          />
          <Route
            path=":id"
            element={
              <ViewRoute
                title="Single view"
                destination="/workspace-1/myvault/views"
              />
            }
          />
        </Route>
      </Routes>
    </MemoryRouter>,
  );

  expect(screen.getByTestId("assistant-widget").textContent).toBe(
    "workspace-1",
  );
  fireEvent.click(screen.getByRole("button", { name: "Views list" }));
  expect(screen.getByRole("button", { name: "Single view" })).toBeTruthy();
  expect(screen.getByTestId("assistant-widget")).toBeTruthy();
  expect(mockWidgetMounted).toHaveBeenCalledTimes(1);
});
